import { TOASTER, LOADER, DATE_RANGEPICKER, SEARCH_QUERY, BILLING_PAYLOAD } from "../../resources/actionTypes";

const initialSettings = {
  billingPayload: {},
  showToaster: "",
  showLoader: false,
  selectedRange: [],
  searchedParams: ""
};

export const commonReducer = (state, action) => {
  if (typeof state === "undefined") {
    return initialSettings;
  }
  switch (action.type) {
    case TOASTER.TOASTER_SHOW:
      return {
        ...state,
        showToaster: action.payload,
      };
    case LOADER.LOADER_TRIGGER:
      return {
        ...state,
        showLoader: action.payload,
      };
      case DATE_RANGEPICKER.DATE_RANGEPICKER_VALUE:
      return {
        ...state,
        selectedRange: action.payload,
      };
      case BILLING_PAYLOAD.BILLING_PAYLOAD_VALUE:
        return {
          ...state,
          billingPayload: action.payload,
        };
      case SEARCH_QUERY.SEARCH_QUERY_VALUE:
        return {
          ...state,
          searchedParams: action.payload,
        };
    default:
      return state;
  }
};
